// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"42.777\" height=\"40.683\" viewBox=\"0 0 42.777 40.683\"> <path d=\"M21.389.288l5.05,15.539H42.777l-13.22,9.605,5.05,15.539-13.218-9.6-13.22,9.6,5.05-15.539L0,15.827H16.339Z\" transform=\"translate(0 -0.288)\"/> </svg> ";
// Exports
module.exports = code;